// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  color: #ffffff;
  border: none;
}

.contact {
  text-align: center;
  margin: 0 auto;
  padding: 10% 0 5% 0;
  border-bottom: 1px solid #f8f8f8;
}
.contact p {
  padding-bottom: 20px;
}
.contact .form-input {
  position: relative;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
}
@media screen and (min-width: 767px) {
  .contact .form-input {
    width: 670px;
  }
}
.contact .form-input input {
  border: 1px solid #f8f8f8;
  padding: 20px 8px 20px 24px;
  color: #b2b2b2;
  outline: none;
  display: block;
  width: 100%;
  text-align: left;
  background-color: transparent;
}
.contact .custom-button {
  color: #171c1f;
  margin: 16px 0;
  padding: 8px 16px;
} `, "",{"version":3,"sources":["webpack://./src/pages/Contact/contact.scss","webpack://./src/pages/Contact/contact.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;ACCF;;ADEA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;ACCF;ADAE;EACE,oBAAA;ACEJ;ADAE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;ACEJ;ADDI;EALF;IAMI,YAAA;ECIJ;AACF;ADHI;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;ACKN;ADDE;EACE,cAAA;EACA,cAAA;EACA,iBAAA;ACGJ","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  border: none;\n}\n\n.contact {\n  text-align: center;\n  margin: 0 auto;\n  padding: 10% 0 5% 0;\n  border-bottom: 1px solid #f8f8f8;\n  p {\n    padding-bottom: 20px;\n  }\n  .form-input {\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    @media screen and (min-width: 767px) {\n      width: 670px;\n    }\n    input {\n      border: 1px solid #f8f8f8;\n      padding: 20px 8px 20px 24px;\n      color: #b2b2b2;\n      outline: none;\n      display: block;\n      width: 100%;\n      text-align: left;\n      background-color: transparent;\n    }\n  }\n\n  .custom-button {\n    color: #171c1f;\n    margin: 16px 0;\n    padding: 8px 16px;\n  }\n}\n","* {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  border: none;\n}\n\n.contact {\n  text-align: center;\n  margin: 0 auto;\n  padding: 10% 0 5% 0;\n  border-bottom: 1px solid #f8f8f8;\n}\n.contact p {\n  padding-bottom: 20px;\n}\n.contact .form-input {\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n@media screen and (min-width: 767px) {\n  .contact .form-input {\n    width: 670px;\n  }\n}\n.contact .form-input input {\n  border: 1px solid #f8f8f8;\n  padding: 20px 8px 20px 24px;\n  color: #b2b2b2;\n  outline: none;\n  display: block;\n  width: 100%;\n  text-align: left;\n  background-color: transparent;\n}\n.contact .custom-button {\n  color: #171c1f;\n  margin: 16px 0;\n  padding: 8px 16px;\n} /*# sourceMappingURL=contact.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
